import React from 'react';
import { 
  FaMapMarkerAlt, 
  FaEnvelope, 
  FaPhone,
  FaWhatsapp,
  FaLinkedin, 
  FaFacebook, 
  FaTwitter,
  FaArrowUp
} from 'react-icons/fa';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const scrollToSection = (e, id) => {
    e.preventDefault();
    const element = document.getElementById(id);
    if (element) {
      window.scrollTo({
        top: element.offsetTop - 80,
        behavior: 'smooth'
      });
    }
  };

  return (
    <footer id="footer" className="bg-gray-900 text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          {/* Company Info */}
          <div>
            <div className="flex items-center mb-4">
              <a 
                href="#hero" 
                onClick={(e) => scrollToSection(e, 'hero')}
                className="mr-3 flex items-center"
              >
                <img 
                  src="./img/logo.jpeg" 
                  alt="Ramwin Technology Logo" 
                  className="h-14 w-14 object-contain rounded-full bg-white bg-opacity-10 p-2 border border-blue-500 border-opacity-30 hover:border-blue-400 transition-all duration-300"
                />
              </a>
            </div>
            <p className="text-gray-400 mb-4 leading-relaxed">
              Pioneering the future of IT technology with research-backed solutions for businesses worldwide.
            </p>
            <div className="flex space-x-4">
              <a 
                href="https://www.linkedin.com/company/ramwin-technology-pvt-ltd" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-blue-500 transition-colors duration-300"
                aria-label="LinkedIn"
              >
                <FaLinkedin className="text-2xl" />
              </a>
              <a 
                href="https://facebook.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-blue-600 transition-colors duration-300"
                aria-label="Facebook"
              >
                <FaFacebook className="text-2xl" />
              </a>
              <a 
                href="https://twitter.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-blue-400 transition-colors duration-300"
                aria-label="Twitter"
              >
                <FaTwitter className="text-2xl" />
              </a>
            </div>
          </div>

          {/* Our Work */}
          <div>
            <h4 className="text-lg font-semibold mb-4 text-white">Our Work</h4>
            <ul className="space-y-2">
              <li>
                <a 
                  href="#products" 
                  onClick={(e) => scrollToSection(e, 'products')}
                  className="text-gray-400 hover:text-blue-500 transition-colors duration-300"
                >
                  Accounting Software
                </a>
              </li>
              <li>
                <a 
                  href="#products" 
                  onClick={(e) => scrollToSection(e, 'products')}
                  className="text-gray-400 hover:text-blue-500 transition-colors duration-300"
                >
                  Learning Management System
                </a>
              </li>
              <li>
                <a 
                  href="#products" 
                  onClick={(e) => scrollToSection(e, 'products')}
                  className="text-gray-400 hover:text-blue-500 transition-colors duration-300"
                >
                  School ERP System
                </a>
              </li>
              <li>
                <a 
                  href="#services" 
                  onClick={(e) => scrollToSection(e, 'services')}
                  className="text-gray-400 hover:text-blue-500 transition-colors duration-300"
                >
                  Web Development
                </a>
              </li>
              <li>
                <a 
                  href="#services" 
                  onClick={(e) => scrollToSection(e, 'services')}
                  className="text-gray-400 hover:text-blue-500 transition-colors duration-300"
                >
                  Mobile App Development
                </a>
              </li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="text-lg font-semibold mb-4 text-white">Company</h4>
            <ul className="space-y-2">
              <li>
                <a 
                  href="#about" 
                  onClick={(e) => scrollToSection(e, 'about')}
                  className="text-gray-400 hover:text-blue-500 transition-colors duration-300"
                >
                  About Us
                </a>
              </li>
              <li>
                <a 
                  href="#team" 
                  onClick={(e) => scrollToSection(e, 'team')}
                  className="text-gray-400 hover:text-blue-500 transition-colors duration-300"
                >
                  Our Team
                </a>
              </li>
              <li>
                <a 
                  href="#contact" 
                  onClick={(e) => scrollToSection(e, 'contact')}
                  className="text-gray-400 hover:text-blue-500 transition-colors duration-300"
                >
                  Contact
                </a>
              </li>
              <li>
                <a 
                  href="#faq" 
                  onClick={(e) => scrollToSection(e, 'faq')}
                  className="text-gray-400 hover:text-blue-500 transition-colors duration-300"
                >
                  FAQ
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold mb-4 text-white">Contact Us</h4>
            <ul className="space-y-3">
              <li className="flex items-start">
                <FaMapMarkerAlt className="text-blue-500 mr-3 mt-1 flex-shrink-0" />
                <span className="text-gray-400">
                  Ramwin Technology Private Limited<br />
                  Matwari, Hazaribag,<br />
                  Jharkhand, India 825301
                </span>
              </li>
              <li className="flex items-start">
                <FaEnvelope className="text-blue-500 mr-3 mt-1 flex-shrink-0" />
                <a 
                  href="mailto:support@ramwintech.com" 
                  className="text-gray-400 hover:text-blue-500 transition-colors duration-300"
                >
                  support@ramwintech.com
                </a>
              </li>
              <li className="flex items-start">
                <FaPhone className="text-blue-500 mr-3 mt-1 flex-shrink-0" />
                <a 
                  href="tel:+918939921400" 
                  className="text-gray-400 hover:text-blue-500 transition-colors duration-300"
                >
                  +91 89399 21400
                </a>
              </li>
              <li className="flex items-start">
                <FaWhatsapp className="text-green-500 mr-3 mt-1 flex-shrink-0" />
                <a 
                  href="https://wa.me/918939921400" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-gray-400 hover:text-green-500 transition-colors duration-300"
                >
                  WhatsApp Us
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 pt-8 mt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="text-gray-400 text-sm mb-4 md:mb-0">
              &copy; {currentYear} <strong className="text-white">Ramwin Technology Private Limited</strong>. All rights reserved.
            </div>
            <div className="flex space-x-6 text-sm">
              <span className="text-gray-400">Made in India</span>
              <button
                onClick={scrollToTop}
                className="text-gray-400 hover:text-blue-500 transition-colors duration-300 flex items-center"
                aria-label="Scroll to top"
              >
                <FaArrowUp className="mr-1" />
                Back to Top
              </button>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;